import { Container } from '@mui/material';
import type {
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPage,
} from 'next';
import Script from 'next/script';
import { FormattedMessage } from 'react-intl';

import { Duration } from 'constants/duration.constants';
import { NOT_FOUND } from 'constants/nextjs.constants';
import { eCommerceQuery } from 'queries/merch/queries';
import Prefetcher from 'services/prefetcher';

import AppNavigation from 'components/@navigation/AppNavigation';
import PageBreadcrumbs from 'components/@navigation/PageBreadcrumbs';
import PageSeo from 'components/@seo/PageSeo';

const Store: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoTags,
}) => {
  return (
    <AppNavigation>
      <PageSeo tags={seoTags} />
      <PageBreadcrumbs
        items={[{ label: <FormattedMessage id="account.merchandise.label" /> }]}
      />
      <Container sx={{ px: { xs: 1, md: 2 } }}>
        <Script
          src="https://app.ecwid.com/script.js?106974757&data_platform=code&data_date=2024-07-31"
          strategy="lazyOnload"
          data-cfasync="false"
          onLoad={() => {
            if (typeof window !== 'undefined' && window.xProductBrowser) {
              window.xProductBrowser(
                'categoriesPerRow=3',
                'views=grid(20,3) list(60) table(60)',
                'categoryView=grid',
                'searchView=list',
                'id=my-store-106974757',
              );
            }
          }}
        />
        <div id="my-store-106974757"></div>
      </Container>
    </AppNavigation>
  );
};

export default Store;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  const { pageECommerce } = await prefetcher.prefetch(eCommerceQuery);

  if (!pageECommerce) return { ...NOT_FOUND };

  const seoTags = pageECommerce.seoTags;
  const dehydratedState = prefetcher.dehydratedState;

  return {
    props: { seoTags, dehydratedState },
    revalidate: Duration.TEN_MIN,
  };
};
